import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=9fb66ea6&scoped=true&"
import script from "./profile.vue?vue&type=script&lang=js&"
export * from "./profile.vue?vue&type=script&lang=js&"
import style0 from "./profile.vue?vue&type=style&index=0&id=9fb66ea6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb66ea6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fb66ea6')) {
      api.createRecord('9fb66ea6', component.options)
    } else {
      api.reload('9fb66ea6', component.options)
    }
    module.hot.accept("./profile.vue?vue&type=template&id=9fb66ea6&scoped=true&", function () {
      api.rerender('9fb66ea6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/profile/personalProfile/profile.vue"
export default component.exports